import * as React from 'react';
import Page from '../containers/Page';
import TasksList from '../containers/TasksList';

export default function CheckboxesGroup() {
  return (<Page title="Inbox">
             <TasksList inbox={true}/>
          </Page>
  );
}